import { createSlice } from "@reduxjs/toolkit";

/**========================================================================
 *                             initial State
 *
 *
 *
 *
 *========================================================================**/
const initialState = {
  phoneNumber: "",
  orderViewData: {},
  orderViewIdSelected: "",
  messages: [],
  organizationMsgSend: [],
  customerUserId: "",
  viewModal: false,
  organizationMsgEdit: {},
  organizationMessageResponse: [],
  compairOrderModal: false,

  //pagnation
  OrderPage: 1,
  OrderPageSize: 35,
  OrderTotal: 10,
  excelFileUrl:"",
  //Toast
  showToast: false,
  //ui access actionControles
  actionsControle: [],
  damageFormState: 0,
  captcha: false,
  updateLogInCount: false,
  //moduleMenu
  activeModule:"",

  appSetting:{
    mainMenuSeacrh:true,
  }

  
};

/**========================================================================
 *                             Reducer
 *
 *
 *
 *
 *========================================================================**/

const setDamageFormState = (state, action) => {
  state.damageFormState = action.payload;
};

const getPhoneNumber = (state, action) => {
  state.phoneNumber = action.payload;
};
const closeViewoeModal = (state) => {
  state.viewModal = false;
  state.organizationMsgSend = [];
  state.orderViewData = {};
  state.orderViewIdSelected = "";
};
const openVieweModal = (state) => {
  state.viewModal = true;
};
const getorderViewIdSelected = (state, action) => {
  state.orderViewIdSelected = action.payload;
};
const getOrderViewData = (state, action) => {
  state.orderViewData = action.payload;
};
const getMessages = (state, action) => {
  state.messages = [...state.messages, action.payload];
};
const getCustomerUserId = (state, action) => {
  state.customerUserId = action.payload;
};
const getOrderPageSize = (state, action) => {
  state.OrderPageSize = action.payload;
};
const setOrderPage = (state, action) => {
  state.OrderPage = action.payload;
};
const getOrderTotal = (state, action) => {
  state.OrderTotal = action.payload;
};

const getExcelFileUrl = (state, action) => {
  state.excelFileUrl = action.payload;
};
const clearOrderTotal=(state)=>{
  state.OrderTotal =0;
}
const getOrganizationMsgSend = (state, action) => {
  state.organizationMsgSend = [...state.organizationMsgSend, action.payload];
};
const getOrganizationMsgEdit = (state, action) => {
  state.organizationMsgEdit = action.payload;
};
const openCompairOrderModal = (state) => {
  state.compairOrderModal = true;
};
const closeCompairOrderModal = (state) => {
  state.compairOrderModal = false;
};

const CallshowToast = (state, action) => {
  state.showToast = action.payload;
};

const setActionsControle = (state, action) => {
  state.actionsControle = action.payload;
};
const setCaptch = (state, action) => {
  state.captcha = action.payload;
};
const setUpdateLogInCount = (state, action) => {
  state.updateLogInCount = action.payload;
};
const setActiveModule=(state, action)=>{
  state.activeModule=action.payload
}

//  appSetting:{
  //   mainMenuSeacrh:true,
  // }

const updateAppSetting=(state, {payload})=>{
  let{key,checked:value}=payload
  state.appSetting[key]=value
}
/**========================================================================
 *                             Slice
 *
 *
 *
 *
 *========================================================================**/
const GeneralSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    getPhoneNumber,
    openVieweModal,
    closeViewoeModal,
    getorderViewIdSelected,
    getOrderViewData,
    getMessages,
    getCustomerUserId,
    getOrderPageSize,
    setOrderPage,
    getOrderTotal,
    getExcelFileUrl,
    clearOrderTotal,
    getOrganizationMsgSend,
    getOrganizationMsgEdit,
    openCompairOrderModal,
    closeCompairOrderModal,
    CallshowToast,
    setActionsControle,
    setDamageFormState,
    setCaptch,
    setUpdateLogInCount,
    setActiveModule,
    updateAppSetting
  },
});

/**========================================================================
 *                             Export
 *
 *
 *
 *
 *========================================================================**/

export const {
  getPhoneNumber: getPhoneNumberR,
  getorderViewIdSelected: getorderViewIdSelectedR,
  getOrderViewData: getOrderViewDataR,
  getMessages: getMessagesR,
  getCustomerUserId: getCustomerUserIdR,
  getOrderPageSize: getOrderPageSizeR,
  setOrderPage: setOrderPageR,
  getOrderTotal: getOrderTotalR,
  getExcelFileUrl:getExcelFileUrlR,
  clearOrderTotal:clearOrderTotalR,
  getOrganizationMsgSend: getOrganizationMsgSendR,
  closeViewoeModal: closeViewoeModalR,
  openVieweModal: openVieweModalR,
  getOrganizationMsgEdit: getOrganizationMsgEditR,
  closeCompairOrderModal: closeCompairOrderModalR,
  openCompairOrderModal: openCompairOrderModalR,
  CallshowToast: CallshowToastR,
  setActionsControle: setActionsControleR,
  setDamageFormState: setDamageFormStateR,
  setCaptch: setCaptchR,
  setUpdateLogInCount: setUpdateLogInCountR,
  setActiveModule:setActiveModuleR,
  updateAppSetting:updateAppSettingR
} = GeneralSlice.actions;

export default GeneralSlice.reducer;
